// PageNavMenuCompanyItem
// ***********************************************************************************************************************
import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { ICompanyMenuItem } from "ui/Scripts/source/models/company/companyMenuItem";
import { CompanyItem } from "../CompanyItem";
import { Box, Typography } from "@mui/material";
import { Dropdown } from "ui/Scripts/source/components/framework/Dropdown/Dropdown";
import { AvatarImage } from "ui/Scripts/source/components/framework/Avatar/AvatarImage";

export interface IPageNavMenuItemCompanyProp {
    classes?: boolean;
    companies: ICompanyMenuItem[];
    hidden?: boolean;
    activeCompanyId: string;
    onChangeActiveCompany: (companyId: string) => void;
}

export class PageNavMenuCompanyItem extends React.Component<IPageNavMenuItemCompanyProp, {}> {
    render() {
        const props = this.props;
        if (props.hidden) return null;
        const companies = props.companies;
        if (!companies || companies.length < 2) return null;
        const selectedCompany = companies.find((company) => company.id === props.activeCompanyId);

        return (
            <>
                <Typography fontWeight={600} sx={{ padding: "0 1rem" }}>{Translations.Company}</Typography>
                <Box sx={{ padding: ".5rem" }}>
                    <Dropdown
                        autoHeight={true}
                        selectedTitle={selectedCompany?.name}
                        startIcon={
                            <AvatarImage
                                size={24}
                                name={selectedCompany?.name}
                                image={selectedCompany?.logo}
                                tooltip={selectedCompany?.name}
                                marginRight={".5rem"}
                            />
                        }
                        selectMode={true}
                        actions={props.companies.map((company) => {
                            return {
                                title: <CompanyItem company={company} />,
                                textTitle: company.name,
                                selected: props.activeCompanyId === company.id,
                                disabled: !company.active,
                                onClick: () => props.onChangeActiveCompany(company.id)
                            };
                        })}
                    />
                </Box>
            </>
        );
    }
}